var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable, Output, EventEmitter } from '@angular/core';
import { HelperServiceService } from '../helpers/helper-service.service';
import * as $config from '../../configuration/config.js';
import * as $ from 'node_modules/jquery/dist/jquery';
var DomOpsService = /** @class */ (function () {
    function DomOpsService(helper) {
        this.helper = helper;
        this.createRepoWidgetCreated = false;
        this.commandCardCounter = 1;
        this.widgets = $("#widgets");
        this.commandPromptEnteredWithValue = new EventEmitter();
        this.commandPromptEnteredEmpty = new EventEmitter();
        this.intentIdentified = new EventEmitter();
        this.widgetIdentified = new EventEmitter();
        this.repeatRequested = new EventEmitter();
    }
    DomOpsService.prototype.displayIntentBox = function (intent) {
        var intentBox = document.getElementById("intentBox");
        if (!this.isVisible(intentBox)) {
            intentBox.classList.remove("hide");
            this.intentIdentified.emit();
        }
        $("#intentName").text($config.intentSlugToOperations[intent].intentMessage + " [slug: " + intent + "].");
    };
    DomOpsService.prototype.showEmptyCommandMessage = function (message) {
        $("#randomModal").text(message);
        $("#emptyCommandMsgDisplayer").click();
        this.commandPromptEnteredEmpty.emit();
    };
    DomOpsService.prototype.populateRecastData = function (widgetName, recastResponse) {
        var operation = $config.intentSlugToOperations[widgetName].populateDataOperation;
        if (typeof this[operation] === "function") {
            this[operation](recastResponse);
        }
    };
    DomOpsService.prototype.populateCreateRepoData = function (recastResponse) {
        var repoNameTextField = document.getElementById("repositoryName");
        if (repoNameTextField && recastResponse && recastResponse.entities["git-repository"] && recastResponse.entities["git-repository"].length > 0
            && recastResponse.entities["git-repository"]["0"].value) {
            var repoName = recastResponse.entities["git-repository"]["0"].value;
            repoNameTextField.value = repoName;
        }
    };
    DomOpsService.prototype.populateCreateIssueData = function (recastResponse) {
        var issueTitleTextField = document.getElementById("issueTitle");
        var issueRepositoryTextField = document.getElementById("issueRepository");
        if (issueTitleTextField && recastResponse && recastResponse.entities.issue_title && recastResponse.entities.issue_title.length > 0
            && recastResponse.entities.issue_title["0"].value) {
            var issueTitle = recastResponse.entities.issue_title["0"].value;
            issueTitleTextField.value = issueTitle;
        }
        if (issueRepositoryTextField && recastResponse && recastResponse.entities["git-repository"] && recastResponse.entities["git-repository"].length > 0
            && recastResponse.entities["git-repository"]["0"].value) {
            var repoName = recastResponse.entities["git-repository"]["0"].value;
            issueRepositoryTextField.value = repoName;
        }
    };
    DomOpsService.prototype.populateCloseIssueData = function (recastResponse) {
        var issueNumberTextField = document.getElementById("issueNumerToClose");
        var issueRepositoryTextField = document.getElementById("repoForIssueClose");
        if (issueNumberTextField && recastResponse && recastResponse.entities.issue_id && recastResponse.entities.issue_id.length > 0
            && recastResponse.entities.issue_id["0"].value) {
            var issueNumber = recastResponse.entities.issue_id["0"].value;
            issueNumberTextField.value = issueNumber;
        }
        if (issueRepositoryTextField && recastResponse && recastResponse.entities["git-repository"] && recastResponse.entities["git-repository"].length > 0
            && recastResponse.entities["git-repository"]["0"].value) {
            var repoName = recastResponse.entities["git-repository"]["0"].value;
            issueRepositoryTextField.value = repoName;
        }
    };
    DomOpsService.prototype.populateAddCollaboratorData = function (recastResponse) {
        var collaboratorNameTextField = document.getElementById("collaboratorName");
        var repoForCollabTextField = document.getElementById("repoForCollab");
        if (collaboratorNameTextField && recastResponse && recastResponse.entities.git_collaborator && recastResponse.entities.git_collaborator.length > 0
            && recastResponse.entities.git_collaborator["0"].value) {
            var collaboratorName = recastResponse.entities.git_collaborator["0"].value;
            collaboratorNameTextField.value = collaboratorName;
        }
        if (repoForCollabTextField && recastResponse && recastResponse.entities["git-repository"] && recastResponse.entities["git-repository"].length > 0
            && recastResponse.entities["git-repository"]["0"].value) {
            var repoName = recastResponse.entities["git-repository"]["0"].value;
            repoForCollabTextField.value = repoName;
        }
    };
    DomOpsService.prototype.populateAddCommentData = function (recastResponse) {
        var repoForIssueCommentTextField = document.getElementById("repoForIssueComment");
        var issueNumberTextField = document.getElementById("issueNumber");
        var issueCommentTextArea = document.getElementById("issueComment");
        if (repoForIssueCommentTextField && recastResponse && recastResponse.entities["git-repository"] && recastResponse.entities["git-repository"].length > 0
            && recastResponse.entities["git-repository"]["0"].value) {
            var repoForIssueComment = recastResponse.entities["git-repository"]["0"].value;
            repoForIssueCommentTextField.value = repoForIssueComment;
        }
        if (issueNumberTextField && recastResponse && recastResponse.entities.issue_id && recastResponse.entities.issue_id.length > 0
            && recastResponse.entities.issue_id["0"].value) {
            var issueNumber = recastResponse.entities.issue_id["0"].value;
            issueNumberTextField.value = issueNumber;
        }
        if (issueCommentTextArea && recastResponse && recastResponse.entities.issue_comment && recastResponse.entities.issue_comment.length > 0
            && recastResponse.entities.issue_comment["0"].value) {
            var issueComment = recastResponse.entities.issue_comment["0"].value;
            issueCommentTextArea.value = issueComment;
        }
    };
    DomOpsService.prototype.populateDisplayCommentData = function (recastResponse) {
        var issueNumberTextField = document.getElementById("issueNumberForCommentView");
        var issueRepositoryTextField = document.getElementById("repoForCommentView");
        if (issueNumberTextField && recastResponse && recastResponse.entities.issue_id && recastResponse.entities.issue_id.length > 0
            && recastResponse.entities.issue_id["0"].value) {
            var issueNumber = recastResponse.entities.issue_id["0"].value;
            issueNumberTextField.value = issueNumber;
        }
        if (issueRepositoryTextField && recastResponse && recastResponse.entities["git-repository"] && recastResponse.entities["git-repository"].length > 0
            && recastResponse.entities["git-repository"]["0"].value) {
            var repoName = recastResponse.entities["git-repository"]["0"].value;
            issueRepositoryTextField.value = repoName;
        }
    };
    DomOpsService.prototype.isVisible = function (element) {
        return element ? !element.classList.contains("hide") : false;
    };
    DomOpsService.prototype.getDataFromFormAsJSON = function () {
        var data = {};
        // const intent = $(`#${$config.constants.hiddenIntentFieldId}`).val();
        var intent = window.localStorage.getItem($config.constants.hiddenIntentFieldId);
        var requestMethod = $config.intentSlugToOperations[intent].requestMethod;
        if (intent) {
            var operation = $config.intentSlugToOperations[intent].getDataOperation;
            if (typeof this[operation] === "function") {
                data = this[operation]();
            }
        }
        return data;
    };
    DomOpsService.prototype.getCreateRepoJson = function () {
        var data = {};
        var request = {};
        if (this.isVisible(document.getElementById("createrepo"))) {
            request.name = document.getElementById("repositoryName").value;
            request.description = document.getElementById("description").value;
            request.homepage = document.getElementById("homePageURL").value;
            request.private = document.getElementById("privateRepoChk").checked;
            request.has_issues = document.getElementById("issuesChk").checked;
            request.has_wiki = document.getElementById("wikiChk").checked;
        }
        data.request = request;
        return data;
    };
    DomOpsService.prototype.getCreateIssueJson = function () {
        var data = {};
        data.urlParams = {};
        var request = {};
        if (this.isVisible(document.getElementById("createissue"))) {
            request.title = document.getElementById("issueTitle").value;
            request.body = document.getElementById("description").value;
            request.assignees = document.getElementById("assignees").value ? document.getElementById("assignees").value.split(",") : [];
            request.labels = document.getElementById("labels").value ? document.getElementById("labels").value.split(",") : [];
            data.urlParams.repoName = document.getElementById("issueRepository").value;
        }
        data.request = request;
        return data;
    };
    DomOpsService.prototype.getCloseIssueJson = function () {
        var data = {};
        data.urlParams = {};
        if (this.isVisible(document.getElementById("closeissue"))) {
            data.urlParams.issueId = document.getElementById("issueNumerToClose").value;
            data.urlParams.repoName = document.getElementById("repoForIssueClose").value;
        }
        return data;
    };
    DomOpsService.prototype.getAddCollaboratorJson = function () {
        var data = {};
        data.urlParams = {};
        if (this.isVisible(document.getElementById("addcollab"))) {
            data.urlParams.collaborator = document.getElementById("collaboratorName").value;
            data.urlParams.repoName = document.getElementById("repoForCollab").value;
        }
        return data;
    };
    DomOpsService.prototype.getAddCommentJson = function () {
        var data = {};
        data.urlParams = {};
        var request = {};
        if (this.isVisible(document.getElementById("addissuecomment"))) {
            request.body = document.getElementById("issueComment").value;
            data.urlParams.issueId = document.getElementById("issueNumber").value;
            data.urlParams.repoName = document.getElementById("repoForIssueComment").value;
        }
        data.request = request;
        return data;
    };
    DomOpsService.prototype.getDisplayCommentJson = function () {
        var data = {};
        data.urlParams = {};
        if (this.isVisible(document.getElementById("displaylastcomment"))) {
            data.urlParams.issueId = document.getElementById("issueNumberForCommentView").value;
            data.urlParams.repoName = document.getElementById("repoForCommentView").value;
        }
        return data;
    };
    DomOpsService.prototype.addGitOperationHistory = function (data) {
        var intent = data.intent;
        // const intent = "createrepo";
        var requestMethod = "";
        if (intent) {
            requestMethod = $config.intentSlugToOperations[intent].requestMethod;
        }
        var conversations = document.getElementById("conversations");
        var table;
        var comment;
        // Create Elements
        var card = document.createElement("div");
        var cardBody = document.createElement("div");
        var cardTitle = document.createElement("h5");
        var closeAnchor = document.createElement("a");
        var closeHeader = document.createElement("h6");
        var cardText = document.createElement("p");
        var cardFooter = document.createElement("div");
        var textMuted = document.createElement("small");
        var underCardLine = document.createElement("div");
        // Add Attributes
        card.classList.add("card");
        cardBody.classList.add("card-body");
        cardTitle.classList.add("card-title");
        closeAnchor.classList.add("close");
        // closeAnchor.setAttribute('href', '#');
        cardText.classList.add("card-text");
        cardFooter.classList.add("card-footer");
        textMuted.classList.add("text-muted");
        underCardLine.classList.add("line");
        // Add content
        closeHeader.innerHTML = "x";
        // const x = this.display_ct(0, textMuted);
        if (data.type === "command") {
            // Add content
            cardTitle.innerHTML = "You Said";
            cardText.innerHTML = data.command;
            card.classList.add("light-red");
            var repeat = document.createElement("a");
            repeat.classList.add("btn", "btn-info", "float-right");
            repeat.setAttribute("role", "button");
            repeat.setAttribute("href", "#");
            repeat.setAttribute("id", "btnRepeatCommand" + data.insertionCounter);
            repeat.innerHTML = "Repeat";
            cardText.appendChild(repeat);
        }
        else if (data.type === "response") {
            // Add content
            cardTitle.innerHTML = "Server Responded As..";
            if (requestMethod == "post") {
                cardText.innerHTML = $config.intentSlugToOperations[intent].cardMsg + "<a class='repoLink' href='" + data[$config.intentSlugToOperations[intent].cardDataUrl] + "'>" + this.getVariable(data, $config.intentSlugToOperations[intent].cardDataName) + "</a>";
            }
            else if (requestMethod == "get") {
                cardText.innerHTML = $config.intentSlugToOperations[intent].cardMsg;
                if (data && data.length && data.length > 0) {
                    if (intent === "viewrepos") {
                        table = this.createRepoTable(data);
                    }
                    else if (intent === "displaylastcomment") {
                        comment = this.createCommentBody(data);
                    }
                }
            }
            else if (requestMethod == "purge") {
                cardTitle.innerHTML = "Operation Completed!";
                cardText.innerHTML = data.command;
            }
        }
        else if (data.type = 'widget') {
            cardTitle.innerHTML = "Operation recorded with below data, click submit to repeat.";
            cardText.innerHTML = $config.intentSlugToOperations[intent].cardMsg;
            if (data && data.length && data.length > 0) {
                if (intent === "viewrepos") {
                    table = this.createRepoTable(data);
                }
                else if (intent === "displaylastcomment") {
                    comment = this.createCommentBody(data);
                }
            }
        }
        else {
            cardTitle.innerHTML = "Server Responded As..";
            cardText.innerHTML = "Operation failed with status: " + data.status;
        }
        // Associations
        closeAnchor.appendChild(closeHeader);
        cardTitle.appendChild(closeAnchor);
        cardBody.appendChild(cardTitle);
        cardBody.appendChild(cardText);
        if (comment) {
            cardBody.appendChild(comment);
        }
        cardFooter.appendChild(textMuted);
        card.appendChild(cardBody);
        if (table) {
            card.appendChild(table);
        }
        card.appendChild(cardFooter);
        conversations.insertBefore(underCardLine, conversations.firstChild);
        conversations.insertBefore(card, conversations.firstChild);
    };
    DomOpsService.prototype.getVariable = function (data, commaSeparatedValue) {
        var arr = commaSeparatedValue.split(",");
        for (var i = 0; i < arr.length; i++) {
            data = data[arr[i]];
        }
        return data;
    };
    // Create table of repositories ==================================================================================================
    DomOpsService.prototype.createRepoTable = function (data) {
        // Create Elements
        var table = document.createElement("table");
        var thead = document.createElement("thead");
        var tr_head = document.createElement("tr");
        var th_1 = document.createElement("th");
        var th_2 = document.createElement("th");
        var th_3 = document.createElement("th");
        var th_4 = document.createElement("th");
        var th_5 = document.createElement("th");
        var th_6 = document.createElement("th");
        var th_7 = document.createElement("th");
        // Add Attributes
        table.classList.add("table", "tabled-bordered", "table-striped", "table-hover");
        thead.classList.add("thead-dark");
        th_1.setAttribute("scope", "col");
        th_2.setAttribute("scope", "col");
        th_3.setAttribute("scope", "col");
        th_4.setAttribute("scope", "col");
        th_5.setAttribute("scope", "col");
        th_6.setAttribute("scope", "col");
        th_7.setAttribute("scope", "col");
        // Add Inner HTML
        th_1.innerHTML = "#";
        th_2.innerHTML = "Repository Name";
        th_3.innerHTML = "Repository ID";
        th_4.innerHTML = "Created On";
        th_5.innerHTML = "Created By";
        th_6.innerHTML = "View Raw";
        th_7.innerHTML = "Delete Repository";
        // Associations
        tr_head.appendChild(th_1);
        tr_head.appendChild(th_2);
        tr_head.appendChild(th_3);
        tr_head.appendChild(th_4);
        tr_head.appendChild(th_5);
        tr_head.appendChild(th_6);
        tr_head.appendChild(th_7);
        thead.appendChild(tr_head);
        table.appendChild(thead);
        for (var i = 0; i < data.length; i++) {
            var currentRepo = data[i];
            // Create Elements
            var tbody = document.createElement("tbody");
            var tr_body = document.createElement("tr");
            var th_vertical = document.createElement("th");
            var td_1 = document.createElement("td");
            var td_2 = document.createElement("td");
            var td_3 = document.createElement("td");
            var td_4 = document.createElement("td");
            var td_5 = document.createElement("td");
            var td_6 = document.createElement("td");
            // Add Attributes
            th_vertical.setAttribute("scope", "row");
            tr_body.setAttribute("id", "repoRow" + i);
            // Add Inner HTML
            th_vertical.innerHTML = i + 1 + "";
            td_1.innerHTML = currentRepo.name;
            td_2.innerHTML = "<a href='" + currentRepo.html_url + "' class='repoLink'>" + currentRepo.id + "</a>";
            td_3.innerHTML = currentRepo.created_at;
            td_4.innerHTML = "<a href='" + currentRepo.owner.html_url + "' class='btn btn-info'>" + currentRepo.owner.login + "</a>";
            td_5.innerHTML = "<a href='" + currentRepo.url + "' class='btn btn-info'>View</a>";
            td_6.innerHTML = "<a href='" + currentRepo.owner.html_url + "' class='btn btn-danger'>Delete</a>";
            // Associations
            tr_body.appendChild(th_vertical);
            tr_body.appendChild(td_1);
            tr_body.appendChild(td_2);
            tr_body.appendChild(td_3);
            tr_body.appendChild(td_4);
            tr_body.appendChild(td_5);
            tr_body.appendChild(td_6);
            tbody.appendChild(tr_body);
            table.appendChild(tbody);
        }
        return table;
    };
    DomOpsService.prototype.loadConversations = function (historyAll) {
        var _this = this;
        if (historyAll) {
            historyAll.forEach(function (element) {
                _this.addGitOperationHistory(element);
            });
        }
    };
    DomOpsService.prototype.createCommentBody = function (data) {
        var commentPara = document.createElement("p");
        var lastComment = this.helper.getLatestComment(data);
        commentPara.classList.add("card-text");
        commentPara.innerHTML = "<strong style='color:black'>COMMENT:</strong> <i>" + lastComment + "</i>";
        return commentPara;
    };
    DomOpsService.prototype.concealCodeInUrl = function () {
        var location = new Location();
        location.href = "http://localhost:8080";
        window.location = location;
    };
    DomOpsService.prototype.toggleModals = function (response) {
        var self = this;
        var promise = response.json();
        var intent = $("#" + $config.constants.hiddenIntentFieldId).val();
        $("#submitConfirm").addClass("hide");
        $("#btnCancelConfirm").click();
        $(".modal-backdrop").removeClass("modal-backdrop");
        $("#underWidgetLine").addClass("hide");
        $("#intentBox").addClass("hide");
        $("#widgets").children().addClass("hide");
        if (response && response.status && (response.status === 201 || response.status === 200 || response.status === 204)) {
            $("#successAlert").removeClass("hide");
            promise.then(function (body) {
                $("#op-msg").text($config.intentSlugToOperations[intent].successMessage);
                $("#successAlert").removeClass("hide");
                var action = $config.intentSlugToOperations[intent].response_action;
                body.intent = intent;
                action.payload = body;
                // this.store.dispatch(action);
                // self.addGitOperationHistory(body, 'response');
            });
        }
        else {
            $("#dangerAlert").removeClass("hide");
            // self.addGitOperationHistory(response.status);
        }
        // clear intent
        // $(`#${$config.constants.hiddenIntentFieldId}`).val("");
        window.localStorage.setItem($config.constants.hiddenIntentFieldId, "");
    };
    // V2
    DomOpsService.prototype.repeatCommand = function (card) {
        var command = card.cardContent;
        this.repeatRequested.emit(command);
    };
    // Angular Specific code here
    DomOpsService.prototype.hideNonCards = function () {
        this.commandPromptEnteredWithValue.emit();
    };
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], DomOpsService.prototype, "commandPromptEnteredWithValue", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], DomOpsService.prototype, "commandPromptEnteredEmpty", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], DomOpsService.prototype, "intentIdentified", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], DomOpsService.prototype, "widgetIdentified", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], DomOpsService.prototype, "repeatRequested", void 0);
    DomOpsService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [HelperServiceService])
    ], DomOpsService);
    return DomOpsService;
}());
export { DomOpsService };
"";
//# sourceMappingURL=dom-ops.service.js.map